import React, {useContext} from "react";
import styled from "styled-components";
import Box from "../Box/Box";
import mediaQueries from "../../utils/mediaQueries";
import mapResponsiveProp from "../../utils/mapResponsiveProp";
import {ColumnsContext} from "../Columns/Columns";

const getSizeStyle = scale => `0 0 ${scale * 100}%`;

export const flexMap = {
    "1/2": getSizeStyle(1 / 2),
    "1/3": getSizeStyle(1 / 3),
    "2/3": getSizeStyle(2 / 3),
    "1/4": getSizeStyle(1 / 4),
    "3/4": getSizeStyle(3 / 4),
    "1/5": getSizeStyle(1 / 5),
    "2/5": getSizeStyle(2 / 5),
    "3/5": getSizeStyle(3 / 5),
    "4/5": getSizeStyle(4 / 5),
};

const widthMap = {
    content: "auto",
};

const flexShrinkMap = {
    content: 0,
};

const ColumnOuter = styled.div`
    height: 100%;
    width: 100%;
    min-width: 0;
    ${({width}) => {
        return mediaQueries({
            flex: mapResponsiveProp(width, flexMap),
            width: mapResponsiveProp(width, widthMap),
            flexShrink: mapResponsiveProp(width, flexShrinkMap),
        });
    }};
`;

export default function Column({children, width}) {
    const {
        collapseMobile,
        collapseTablet,
        collapseDesktop,
        mobileSpace,
        tabletSpace,
        desktopSpace,
    } = useContext(ColumnsContext);
    return (
        <ColumnOuter width={width} flexShrink={width} data-test-id="column-outer">
            <Box
                data-test-id="column-inner"
                paddingLeft={[
                    collapseMobile ? "none" : mobileSpace,
                    collapseTablet ? "none" : tabletSpace,
                    collapseDesktop ? "none" : desktopSpace,
                ]}
                paddingTop={
                    collapseMobile || collapseTablet || collapseDesktop
                        ? [
                              collapseMobile ? mobileSpace : "none",
                              collapseTablet ? tabletSpace : "none",
                              collapseDesktop ? desktopSpace : "none",
                          ]
                        : undefined
                }
            >
                {children}
            </Box>
        </ColumnOuter>
    );
}
